module.exports = __webpack_public_path__ + "static/media/trialUserPaginationImg.b9b14485.png";